export const COMPANY = {
  name: "Commercial Client Acquisition",
  short: "CCA",
  legal: "Commercial Client Acquisition, LLC",
  category: "Commercial Insurance Pipeline Development",
  tagline: "Disciplined pipeline development for commercial insurance agencies.",
  email: "support@commercialclientacquisition.com",
  phone: "307-363-2223",
  location: "United States",
};

export const NAV = [
  { label: "Why CCA", to: "/why-cca" },
  { label: "How It Works", to: "/how-it-works" },
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const DIFFERENTIATORS = [
  {
    n: "01",
    title: "Exclusive Commercial Focus",
    body: "We work solely with commercial insurance. No personal lines, no distractions — only the market you compete in every day.",
  },
  {
    n: "02",
    title: "Systems Over Personalities",
    body: "Results are engineered through repeatable processes, not dependent on any single rep's talent, mood, or tenure.",
  },
  {
    n: "03",
    title: "Quality Assurance",
    body: "Every interaction is reviewed against a standard. Consistency is measured, not assumed, and improved continuously.",
  },
  {
    n: "04",
    title: "Leadership Development",
    body: "We build and mentor Pipeline Development Specialists so your program compounds in capability over time.",
  },
  {
    n: "05",
    title: "Professional Communication",
    body: "Your brand is represented with the discipline and polish that commercial decision-makers expect.",
  },
  {
    n: "06",
    title: "Predictable Execution",
    body: "A pipeline you can forecast against — steady, documented, and accountable quarter after quarter.",
  },
];

export const PROCESS = [
  {
    n: "01",
    title: "Discovery & Alignment",
    body: "We map your appetite, target classes, and geography, then align on the ideal commercial prospect and a clear definition of a qualified opportunity.",
  },
  {
    n: "02",
    title: "System Design",
    body: "We build the standardized process: messaging, cadences, data sources, and the quality bar every touch must clear before it reaches you.",
  },
  {
    n: "03",
    title: "Specialist Deployment",
    body: "Trained Pipeline Development Specialists execute the system on your behalf, representing your agency with professional discipline.",
  },
  {
    n: "04",
    title: "Quality Assurance",
    body: "Interactions are reviewed against the standard. We coach, calibrate, and remove variability so output stays consistent.",
  },
  {
    n: "05",
    title: "Accountability & Reporting",
    body: "You receive transparent reporting on activity, quality, and pipeline movement — the numbers you forecast against.",
  },
  {
    n: "06",
    title: "Continuous Improvement",
    body: "We iterate on the system every cycle, compounding performance instead of resetting it.",
  },
];

export const SERVICES = [
  {
    tag: "Core",
    title: "Pipeline Development Program",
    body: "A managed, subscription engagement that builds and maintains a predictable flow of qualified commercial opportunities for your producers.",
    points: ["Dedicated specialist capacity", "Standardized outreach system", "Weekly pipeline reporting"],
  },
  {
    tag: "System",
    title: "Process & Standards Design",
    body: "We architect the messaging, cadences, and quality bar tuned to your appetite and target commercial classes.",
    points: ["Target-class definition", "Message & cadence design", "Qualification criteria"],
  },
  {
    tag: "Assurance",
    title: "Quality Assurance & Calibration",
    body: "Structured review of every engagement against your standard, with coaching that removes variability from results.",
    points: ["Interaction scoring", "Coaching & calibration", "Compliance-minded conduct"],
  },
  {
    tag: "People",
    title: "Specialist Development",
    body: "Recruiting, training, and mentoring Pipeline Development Specialists so your program grows in capability, not just volume.",
    points: ["Structured onboarding", "Leadership track", "Performance standards"],
  },
];

export const MARQUEE = [
  "Commercial Prospecting",
  "Insurance Sales Pipeline",
  "Agency Growth",
  "Producer Prospecting",
  "Quality Assurance",
  "Predictable Execution",
  "Systems Over Personalities",
];

export const STATS = [
  { value: "100%", label: "Commercial insurance focus" },
  { value: "6-Step", label: "Standardized system" },
  { value: "Weekly", label: "Accountability reporting" },
  { value: "0", label: "Prospecting hires to manage" },
];

export const IMAGES = {
  heroArch:
    "https://images.unsplash.com/photo-1512403754473-27835f7b9984?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  glassHall:
    "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  absArch:
    "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  handshake:
    "https://images.unsplash.com/photo-1758518730384-be3d205838e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  execPortrait:
    "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  execMature:
    "https://images.pexels.com/photos/30692588/pexels-photo-30692588.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  team:
    "https://images.pexels.com/photos/8204363/pexels-photo-8204363.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  workstation:
    "https://images.unsplash.com/photo-1556761175-4b46a572b786?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

// CCA recruiting email for the Opportunity funnel CTA.
export const RECRUITING_EMAIL = "support@commercialclientacquisition.com";
export const RECRUITING_SUBJECT = "Consider Me for the CCA Opportunity";
